export default "__VITE_ASSET__BPZel2tS__"